if (!customElements.get('toggle-accordeon')) {
	customElements.define('toggle-accordeon', class extends HTMLElement {
		constructor() {
			super();
			this.contentHeight = this.getContentHeight();
			this.animation = null;
		}

		static get observedAttributes() {
			return ['open'];
		}

		attributeChangedCallback(name) {
			if (name === 'open') {
				if (this.isOpen) {
					this.toggleOpen();
				} else {
					this.toggleClose();
				}
			}
		}

		get detail() {
			return this.querySelector('details');
		}

		get summary() {
			return this.querySelector('summary');
		}

		get isOpen() {
			return this.hasAttribute('open');
		}

		onClickHandler(event) {
			event.preventDefault();
			if (this.isOpen) {
				this.removeAttribute('open');
			} else {
				this.setAttribute('open', '');
			}
		}

		getContentHeight() {
			const children = [...this.detail.children];
			return children.reduce((acc, child) => {
				acc + child.offsetHeight;
				return acc;
			}, 0);
		}

		expand() {
			const endingHeight = `${this.detail.offsetHeight}px`;
			const startingHeight = `${this.summary.offsetHeight}px`;

			if (this.animation) this.cancelAnimation();

			this.animation = this.createAnimation(startingHeight, endingHeight);
			this.animation.commitStyles();
			this.animation.onfinish = this.onCancelAnimation.bind(this);
		}

		collapse() {
			const startingHeight = `${this.offsetHeight}px`;
			const endingHeight = `${this.summary.offsetHeight}px`;

			if (this.animation) this.cancelAnimation();

			this.animation = this.createAnimation(startingHeight, endingHeight);
			this.animation.commitStyles();
			this.animation.onfinish = this.onCancelAnimation.bind(this);
		}

		cancelAnimation() {
			this.animation.oncancel = this.onCancelAnimation.bind(this);
			this.animation.cancel();
		}

		finishAnimation() {
			this.animation.onfinish = this.onCancelAnimation.bind(this);
		}

		createAnimation(startingHeight, endingHeight) {
			return this.detail.animate({ height: [startingHeight, endingHeight] }, {
				duration: 200,
				easing: 'ease-in-out',
			}
			);
		}

		toggleOpen() {
			this.detail.setAttribute('open', '');
			this.detail.style.height = `${this.detail.scrollHeight}px`;
			this.detail.style.overflow = 'hidden';
			requestAnimationFrame(this.expand.bind(this));
		}

		toggleClose() {
			this.detail.style.height = `${this.detail.scrollHeight}px`;
			this.detail.style.overflow = 'hidden';
			requestAnimationFrame(this.collapse.bind(this));
		}

		onCancelAnimation() {
			this.animation = null;
			this.detail.style.height = '';
			this.detail.style.overflow = '';
			if (!this.isOpen) this.detail.removeAttribute('open');
		}

		connectedCallback() {
			this.summary.addEventListener('click', this.onClickHandler.bind(this));
		}
	});
}